<div *ngIf="person; else noPerson"
     class="mention-person d-flex gap-1 align-items-center">
    <adapt-person-image [person]="person"
                        imageSize="sm"></adapt-person-image>
    <span>{{person.fullName}}</span>
</div>
<ng-template #noPerson>
    <p>Loading</p>
</ng-template>
